export class FileUpload {
    $key: string;
    name: string;
    url: string;
    file: File;
    progress: number;
    constructor(file: File) {
      this.file = file;
    }
  }


// WEBPACK FOOTER //
// /app/src/app/core/models/fileupload.ts